import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'; //นำ App.js เข้ามา
import reportWebVitals from './reportWebVitals';




//ไฟล์นี้ทำหน้าที่เชื่อม App.js กับ index.html
// jsx คือการเขียน ไฟล์ html ใน javascript or js
//เเสดงผล COMPONENT app หรือ App.js ไปที่ไฟล์ index.html ตำเเหน่ง root



ReactDOM.render(<App/>,document.getElementById('root'));


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
